export enum Status {
    OPEN = 'OPEN',
    IN_PROCESS = 'IN_PROCESS',
    REALIZED = 'REALIZED',
    REJECTED = 'REJECTED'
}

export const MEASURE_STATUS_KEY_PREFIX = 'ENUM.STATUS.';
export const MEASURE_STATUS_KEY_SUFIX = '.TXT';

export function getMeasureStatusTranslationKey(status: Status): string {
    return `${MEASURE_STATUS_KEY_PREFIX}${status}${MEASURE_STATUS_KEY_SUFIX}`;
}

export const measureStatusTranslationKeys = Object.values(Status).reduce((translationKeys, status) => {
    translationKeys[status] = getMeasureStatusTranslationKey(status);
    return translationKeys;
}, {} as Record<Status, string>);
